const Footer = () => {
    return (
        <div className='mt-2 w-full'>
            <span className='float-left text-[#8b8b8b] text-[12px]'>
                &copy; {new Date().getFullYear()} MASSA EDGE
            </span>
        </div>
    )
}

export default Footer
